<template>
  <span class="key">
    <!-- Key char -->
    <slot></slot>
  </span>
</template>

<script>
// @group Dialog
// Keyboard key
export default {
  name: "ShortcutKey"
};
</script>

<style scoped>
.key {
  display: inline-block;
  /** width, paddings, margins */
  min-width: 1em;
  padding: 4px;
  /** border */
  border: 1px solid black;
  border-radius: 5px;
  /** font */
  text-align: center;
  font-weight: bold;
}
</style>
